// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211516/js/" + chunkId + "." + {"44":"a1a945ab","225":"eabdbc90","481":"5f056deb","486":"ebb116f7","770":"22064580"}[chunkId] + ".0.8224354161505669.chunk.js";
};